import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Container, Title, TitleContainer } from './component.styles'

class FirstTimeUserNav extends Component {
  static propTypes = {
    backgroundColor: PropTypes.string,
    title: PropTypes.string,
  }
  render() {
    const { backgroundColor, product } = this.props || {}
    const { title } = product || {}
    return (
      <Container
        backgroundColor={backgroundColor}
        data-testid={'global-nav-container'}
      >
        <TitleContainer>
          <Title data-testid={'global-nav-title'}>{title}</Title>
        </TitleContainer>
      </Container>
    )
  }
}

export default FirstTimeUserNav
